import React from 'react';

export const renderWithBr = (
    value: string | undefined | null,
    fallback: React.ReactNode
): React.ReactNode => {
    if (!value) return fallback;

    const parts = value.replace(/(?:\r\n|\r|\n)/g, '{br}').split('{br}');

    if (parts.length === 1) {
        return parts[0];
    }

    return parts.map((part, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
            {index > 0 && <br />}
            {part}
        </React.Fragment>
    ));
};
